import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import AppRoutes from './routes/routes';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import theme from './theme/theme';
import { validateEnv } from './config/env';

// Fail fast in production when required REACT_APP_* vars are missing.
validateEnv();

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss={true}
          draggable={true}
          pauseOnHover={true}
          theme="light"
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
